export const buildVimeoEmbedUrl = ({
    videoId,
    hash = null,
    autoplay = false,
    loop = false,
    muted = false,
    title = false,
    byline = false,
    portrait = false,
    controls = true,
    color = null, // hex, like '00adef'
    startAt = null, // seconds
    endAt = null, // seconds
    captions = null // language code e.g. 'en', 'nl', 'fr'
}) => {
    if (!videoId) {
        throw new Error('Vimeo videoId is required');
    }

    const base = `https://player.vimeo.com/video/${videoId}`;
    const params = new URLSearchParams();

    // Add privacy hash if provided
    if (hash) params.append('h', hash);

    if (autoplay) params.append('autoplay', '1');
    if (muted) params.append('muted', '1');
    if (loop) params.append('loop', '1');
    if (!controls) params.append('controls', '0');
    if (!title) params.append('title', '0');
    if (!byline) params.append('byline', '0');
    if (!portrait) params.append('portrait', '0');
    if (color) params.append('color', color.replace('#', ''));

    // Add captions if explicitly set
    if (captions) params.append('texttrack', captions);

    // Vimeo uses fragment for start & end time
    let timeFragment = '';
    if (startAt !== null || endAt !== null) {
        timeFragment = '#t=';
        timeFragment += startAt !== null ? `${startAt}s` : '0s';
        if (endAt !== null) timeFragment += `,${endAt}s`;
    }

    return `${base}?${params.toString()}${timeFragment}`;
};
